import {
  User,
  Camera,
  Wallet,
  Coins,
  Receipt,
  ListPlus,
  SlidersHorizontal,
  AlarmClock,
  Tags,
  Calendar,
  Briefcase,
  Cake,
  CheckCircle2,
  FolderPlus,
  ListChecks,
  KeyRound,
  List,
  CheckCheck,
  FolderTree,
  ClipboardList,
  CalendarRange,
  FileSpreadsheet,
  BadgeCheck,
  Users,
  UserPlus,
  Share2,
  TrendingUp,
  Crown,
  MessageCircle,
  LineChart,
  Target,
  Flame,
  Layers,
  BarChart3,
  CheckSquare,
  Banknote,
  HandCoins,
  Gauge,
  Sparkles,
  Gift,
  Goal,
  CircleDollarSign,
  Trophy,
  PiggyBank,
  Award,
  CandlestickChart,
  ArrowUpRight,
  UsersRound,
  Files,
  ShieldCheck,
  Medal,
  BarChart,
  PartyPopper,
  Dumbbell,
  Landmark,
  Rocket,
  Infinity as InfinityIcon,
  Globe,
  Star,
} from 'lucide-react';

export const TONE_GRADIENTS = {
  blue: 'from-blue-500 to-indigo-600',
  purple: 'from-purple-500 to-fuchsia-600',
  emerald: 'from-emerald-500 to-teal-600',
  amber: 'from-amber-500 to-orange-600',
  orange: 'from-orange-500 to-rose-500',
  pink: 'from-pink-500 to-rose-600',
  slate: 'from-slate-500 to-slate-700',
};

export const MISSION_META = {
  // Latão
  'profile-name': { icon: User, tone: 'blue' },
  'profile-avatar': { icon: Camera, tone: 'purple' },
  'profile-income': { icon: Wallet, tone: 'emerald' },
  'profile-currency': { icon: Coins, tone: 'amber' },
  'first-debit': { icon: Receipt, tone: 'orange' },

  // Cobre
  '3-debits': { icon: ListPlus, tone: 'orange' },
  'set-income-mode': { icon: SlidersHorizontal, tone: 'blue' },
  'pay-on-time': { icon: AlarmClock, tone: 'emerald' },
  '3-categories': { icon: Tags, tone: 'purple' },
  '7-days-active': { icon: Calendar, tone: 'amber' },

  // Bronze
  'profile-profession': { icon: Briefcase, tone: 'blue' },
  'profile-age': { icon: Cake, tone: 'pink' },
  'pay-first-debit': { icon: CheckCircle2, tone: 'emerald' },
  'category-custom': { icon: FolderPlus, tone: 'purple' },
  '5-debits': { icon: ListChecks, tone: 'orange' },
  'change-password': { icon: KeyRound, tone: 'slate' },

  // Prata
  '10-debits': { icon: List, tone: 'orange' },
  '5-debits-paid': { icon: CheckCheck, tone: 'emerald' },
  '2-custom-categories': { icon: FolderTree, tone: 'purple' },
  'budget-set': { icon: ClipboardList, tone: 'blue' },
  '30-days-active': { icon: CalendarRange, tone: 'amber' },

  // Ouro
  '15-debits': { icon: FileSpreadsheet, tone: 'orange' },
  'pay-10-debits': { icon: BadgeCheck, tone: 'emerald' },
  'first-group': { icon: Users, tone: 'blue' },
  'invite-member': { icon: UserPlus, tone: 'purple' },
  'share-debit': { icon: Share2, tone: 'pink' },
  'positive-month': { icon: TrendingUp, tone: 'emerald' },

  // Safira
  'upgrade-pro': { icon: Crown, tone: 'amber' },
  'whatsapp-connect': { icon: MessageCircle, tone: 'emerald' },
  'first-investment': { icon: LineChart, tone: 'blue' },
  'first-goal': { icon: Target, tone: 'purple' },
  'pay-streak-7': { icon: Flame, tone: 'orange' },
  '5-categories': { icon: Layers, tone: 'pink' },

  // Esmeralda
  '7-investments': { icon: BarChart3, tone: 'emerald' },
  '2-goals-completed': { icon: CheckSquare, tone: 'blue' },
  'passive-500': { icon: Banknote, tone: 'emerald' },
  '5-dividends': { icon: HandCoins, tone: 'amber' },
  'goal-75pct': { icon: Gauge, tone: 'purple' },

  // Rubi
  '5-investments': { icon: ArrowUpRight, tone: 'emerald' },
  'first-dividend': { icon: Gift, tone: 'pink' },
  '3-goals': { icon: Goal, tone: 'purple' },
  'goal-50pct': { icon: CircleDollarSign, tone: 'emerald' },
  '30-debits-paid': { icon: Trophy, tone: 'amber' },
  'savings-rate-15': { icon: PiggyBank, tone: 'blue' },

  // Diamante
  'goal-completed': { icon: Award, tone: 'amber' },
  '10-investments': { icon: CandlestickChart, tone: 'emerald' },
  'passive-income': { icon: Sparkles, tone: 'purple' },
  '3-groups': { icon: UsersRound, tone: 'blue' },
  '90-debits': { icon: Files, tone: 'orange' },
  'savings-rate-25': { icon: ShieldCheck, tone: 'emerald' },

  // Ultra Raro
  '3-goals-completed': { icon: Medal, tone: 'amber' },
  '25-investments': { icon: BarChart, tone: 'emerald' },
  '1-year-active': { icon: PartyPopper, tone: 'pink' },
  '200-debits-paid': { icon: Dumbbell, tone: 'orange' },
  'passive-1k': { icon: Landmark, tone: 'emerald' },

  // Interplanetário
  '5-goals-completed': { icon: Crown, tone: 'amber' },
  '50-investments': { icon: Rocket, tone: 'purple' },
  'passive-cover-expenses': { icon: InfinityIcon, tone: 'pink' },
  '2-years-active': { icon: Globe, tone: 'blue' },
  'top-100': { icon: Star, tone: 'amber' },
};

export function getMissionMeta(id) {
  return MISSION_META[id] || { icon: Sparkles, tone: 'slate' };
}
